import { GET_ACTIVE_ACTIONS_FOR_USER_URL } from "./endpoints";
import axiosInstance from "./axiosInstance";
import { AxiosRequestConfig, AxiosResponse } from "axios";
import BasicActionDetailsDTO from "./models/BasicActionDetailsDTO";

export const getActiveActionsForUserParams = (
  userId: string
): AxiosRequestConfig =>
  ({
    url: GET_ACTIVE_ACTIONS_FOR_USER_URL(userId),
    method: "GET"
  } as AxiosRequestConfig);

export const getActiveActionsForUser = async (
  userId: string
): Promise<AxiosResponse<BasicActionDetailsDTO[]>> => {
  return await axiosInstance.request(getActiveActionsForUserParams(userId));
};
